<template>
  <div class="animated fadeIn">
    <user-form v-bind:user="this.user" :roles="this.roles" :teams="this.teams" :accounts="this.accounts" :isSuperAdmin="this.isSuperAdmin" :isAdmin="this.isAdmin" :editUser="true" @formSubmit="updateUser" @cancelForm="cancelForm"></user-form>
  </div>
</template>

<script>
import Vue from 'vue'
import router from '../../router'
import { mapGetters } from 'vuex'
import userForm from '@/components/admin/userForm'

export default {
  components: {
    'user-form': userForm
  },
  data () {
    return {
      user: {
        id: '',
        username: '',
        email: '',
        password: null,
        repeat_password: null,
        role_id: null,
        account_id: '',
        team_id: ''
      },
      roles: [],
      accounts: [],
      teams: []
    }
  },
  computed: {
    ...mapGetters(['idToken', 'isSuperAdmin', 'isAdminRole', 'isAdmin'])
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.isAdminRole) {
        Vue.axios.get('/admin/users/' + vm.$route.params.id, { headers: { Authorization: `Bearer ${vm.idToken}` } })
          .then(res => {
            let user = res.data.user
            vm.user.id = user.id
            vm.user.username = user.username
            vm.user.email = user.email
            vm.user.role_id = user.role_id
            vm.user.team_id = user.team_id
            if (vm.user.role_id === 2 && vm.isAdmin) {
              Vue.toasted.show(vm.$t('COMMON.MSG_EDIT_N_A'), { type: 'error' })
              next(false)
              router.push('/admin/users')
            }
            vm.user.account_id = user.account_id
            vm.roles = user.roles
            vm.accounts = user.accounts
            vm.teams = user.teams
            next()
          })
          .catch(error => {
            if (error.status === 401) {
              Vue.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
              console.log(this.$t('COMMON.MSG_EXPIRED'))
            } else {
              Vue.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
              next(false)
            }
          })
      } else {
        router.replace('/Not-Found-404')
      }
    })
  },
  methods: {
    updateUser () {
      let data = new window.FormData()
      data.append('username', this.user.username)
      data.append('email', this.user.email)
      data.append('role_id', this.user.role_id)
      data.append('account_id', this.user.account_id)
      data.append('team_id', this.user.team_id)
      if (this.user.password) { data.append('password', this.user.password) }

      Vue.axios.patch('/admin/users/' + this.user.id, data, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.error) {
            Vue.toasted.show(res.data.error, { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_USER_UPDATE'))
            router.push('/admin/users')
          }
        })
        .catch(error => {
          Vue.toasted.show(this.$t('COMMON.MSG_SIGNUP_FAIL'),
            { icon: 'chain-broken', type: 'error' })
          console.log(error)
        })
    },
    cancelForm () {
      router.push('/admin/users')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/admin/editUser.vue